/* eslint-disable react/prop-types */
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { RxCross1 } from 'react-icons/rx';
import useOrderGuardrails from '../../../hooks/fetch-hooks/order-guardrails/use-order-guardrails';

export default function PreShipmentChecklist({ orderId }) {
    const { data, isLoading, isError } = useOrderGuardrails(orderId);
    const payload = data?.data?.data;

    const failureCount = payload?.failures?.length ?? 0;
    const allPassed = payload?.failures?.length === 0;

    return (
        <div className="bg-white border border-gray-200 rounded-2xl p-4 shadow-soft-xl flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="text-base font-semibold text-gray-800">Pre-Shipment Checklist</h3>
                    <p className="text-xs text-gray-500">Advisory — does not block order flow</p>
                </div>
                {payload && (
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${allPassed ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {allPassed ? 'All checks passed' : `${failureCount} action${failureCount !== 1 ? 's' : ''} needed`}
                    </span>
                )}
            </div>

            {isLoading && <p className="text-sm text-gray-500">Loading checklist...</p>}
            {isError && <p className="text-sm text-red-600">Failed to load guardrails.</p>}

            {payload?.checks && (
                <div className="flex flex-col gap-2">
                    {payload.checks.map((check, idx) => (
                        <div key={idx} className="flex flex-col gap-0.5">
                            <div className="flex items-center gap-2">
                                {check.ok ? (
                                    <FaCheck className="text-green-600 flex-shrink-0" size={13} />
                                ) : (
                                    <RxCross1 className="text-red-600 flex-shrink-0" size={13} />
                                )}
                                <span className={`text-sm ${check.ok ? 'text-gray-700' : 'text-gray-800 font-medium'}`}>
                                    {check.label}
                                </span>
                            </div>
                            {!check.ok && check.message && (
                                <p className="text-sm text-red-600 ml-5">{check.message}</p>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
